import { createFileRoute } from '@tanstack/react-router'

import { RevenueReportsSearchSchema } from '@/pages/brevo/revenue/revenue-report-search'

export const Route = createFileRoute('/_layout/brevo/revenue/')({
  validateSearch: RevenueReportsSearchSchema,
})
